<template>
  <div>
    <div
      class="floated-chat-btn"
      data-target="#entarimarModal"
      data-toggle="modal"
      style="z-index: 1000 !important"
      data-keyboard="false"
      href="#"
      data-backdrop="static"
    >
      <i class="fas fa-check"></i>&nbsp;&nbsp;Entarimar
    </div>
    <div
      class="modal fade"
      id="entarimarModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Entarimar Producto</h5>
            <button
              aria-label="Close"
              class="close"
              @click="cerrarModal()"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <h5>Tarima # {{ tarima.numero }}</h5>
              </div>
              <div class="col-sm-12 row">
                <div class="col-10">
                  <div class="form-group">
                    <label for>Tarima</label>
                    <input
                      class="form-control"
                      placeholder="Tarima"
                      type="text"
                      autocomplete="off"
                      v-model="localizacion_origen"
                    />
                    <small class="form-text text-danger" v-if="errors">{{
                      errors.tarima_barra
                    }}</small>
                  </div>
                </div>
                <div class="col-1">
                  <br />
                  <button @click="Imprimir()" class="btn btn-info btn-lg">
                    <i class="fas fa-print"></i>
                  </button>
                </div>
              </div>
              <h6 style="color: blue" v-if="producto">
                {{ producto.sku }} {{ producto.nombre }}
              </h6>
              <small v-if="errors" class="form-text text-danger">{{
                errors.producto
              }}</small>
              <div class="col-md-12">
                <div class="form-group">
                  <label for>Producto</label>
                  <input
                    v-on:keyup.enter="refreshProducto(barra)"
                    class="form-control"
                    placeholder="Producto"
                    type="text"
                    autocomplete="off"
                    v-model="barra"
                    @input="resetDataProducto"
                  />
                  <small class="form-text text-danger" v-if="errors">{{
                    errors.producto_barra
                  }}</small>
                </div>
              </div>
              <div class="col-sm-12">
                <button
                  @click="refreshProducto(barra)"
                  class="btn btn-sm btn-info btn-block"
                >
                  Buscar
                </button>
                &nbsp;
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for>Cantidad</label>
                  <input
                    class="form-control"
                    placeholder="Cantidad"
                    type="number"
                    autocomplete="off"
                    step="0.01"
                    v-model="cantidad"
                  />
                  <small class="form-text text-danger" v-if="errors">{{
                    errors.cantidad
                  }}</small>
                </div>
              </div>
            </div>
            <small v-if="error_entarimar" class="form-text text-danger">{{
              error_entarimar
            }}</small>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-block btn-primary"
              type="button"
              @click="entarimar"
            >
              Entarimar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import notifications from "../../../notifications/notifications";

export default {
  components: {},
  props: {
    tarima: {
      type: Object,
    },
  },
  data() {
    return {
      error_entarimar: null,
      barra: null,
      localizacion_origen: null,
      cantidad: null,
      tipo: "T",
      errors: [],
      producto: "",
    };
  },
  mounted() {},
  methods: {
    Imprimir() {
      let self = this;
      self.id = self.tarima.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/tarima/tarima.jrxml&id=${self.id}`
      );
    },
    cerrarModal() {
      this.refreshDetalleDefault();
      this.resetDataProducto();
      $("#entarimarModal").modal("hide");
    },
    resetDataProducto() {
      this.producto = [];
      this.errors = [];
    },
    refreshDetalleDefault() {
      let self = this;
      self.localizacion_origen = "";
      self.cantidad = 0;
      self.barra = "";
      self.error_entarimar = "";
      self.errors = "";
      self.producto = [];
    },
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        self.errors.producto = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        activo: true,
      })
        .then((response) => {
          self.producto = response.data.results[0].producto_obj;
          self.errors.producto = "";
        })
        .catch((err) => {
          self.producto = null;
          self.errors.producto = "No existe producto";
        });
    },
    entarimar() {
      let self = this;
      if (!self.producto || self.producto == null) {
        Notifications.alert.error("Producto", "No existe este produco");
        return;
      }
      DynamicService.postAction(
        "wms",
        "tarima",
        self.tarima.id,
        "agregar_producto_a_tarima",
        {
          tarima_barra: self.localizacion_origen,
          producto_barra: self.producto.sku,
          cantidad: self.cantidad,
          tipo: self.tipo,
        }
      )
        .then((res) => {
          $("#entarimarModal").modal("hide");
          console.log(res.data.producto_no_entarimado.producto_no_entarimado);
          if (res.data.producto_no_entarimado.producto_no_entarimado) {
            let productos_no_entarimados =
              res.data.producto_no_entarimado.producto_no_entarimado.toString();
            Notifications.alert.error(
              "El siguiente producto no entarimado.",
              `${productos_no_entarimados} por falta de solicitud o problemas con la estacion, "REVISE LA TARIMA POR FAVOR"`,
              ""
            );
          }
          if (res.data.producto_no_entarimado.length > 0) {
            let productos_no_entarimados =
              res.data.producto_no_entarimado.toString();
            console.log(productos_no_entarimados);
            Notifications.alert.error(
              "Los siguientes productos no fueron entarimados.",
              `${productos_no_entarimados} por falta de solicitud o problemas con la estacion, "REVISE LA TARIMA POR FAVOR"`,
              ""
            );
          }

          self.refreshDetalleDefault();
          self.$emit("refresh_tarima");
          self.data = {
            error_entarimar: null,
            barra: null,
            localizacion_origen: null,
            cantidad: null,
          };
        })
        .catch((err) => {
          console.log(err.response.data);
          self.errors = err.response.data;

          if (err.response.data.detail) {
            notifications.alert.error(
              "Entarimar Producto",
              err.response.data.detail
            );
          }
        });
    },
  },
};
</script>
